import { lazy } from "react";
import HeaderContainer from "./containers/HeaderContainer";
import DefaultGlobalStyle from "@yoon0cean/common/dist/globalStyle/common/DefaultGlobal.style";
import AdvancedSearchPopup from "./components/poiList/popup/AdvancedSearchPopup";

const HtmlHeaderContainer = lazy(
  () => import("./containers/HtmlHeaderContainer")
);

const MainSystem = lazy(() => import("./containers/MainSystem"));

const ContentContainer = lazy(() => import("./containers/ContentContainer"));

const LoadingContainer = lazy(() => import("./containers/LoadingContainer"));

const LocationPopupContainer = lazy(
  () => import("./containers/LocationPopupContainer")
);

const PopupContainer = lazy(() => import("./containers/PopupContainer"));

// window.addEventListener("navermapsload", (e) => {
//   console.log("navermapsload");
// });

function App() {
  // const navigate = useNavigate();

  // useEffect(() => {
  //   const paramFromUrl = getQueryParams();
  //   if (isUrlIncludes("rect")) {
  //     navigate(
  //       setQueryParams({
  //         ...paramFromUrl,
  //         rect: "",
  //       }),
  //       { replace: false }
  //     );
  //   }
  // }, []);

  return (
    <>
      <DefaultGlobalStyle />
      <HtmlHeaderContainer />

      <MainSystem />
      <header className="Header__Content">
        <HeaderContainer />
      </header>
      <LocationPopupContainer />
      <ContentContainer />
      <LoadingContainer />
      <PopupContainer />
      {/* <AdvancedSearchPopup /> */}
    </>
  );
}

export default App;
